<template>
  <div>
    <div
      v-if="render"
      :class="{shown: show}"
      class="cookie_modal">
      <div class="container">
        <div class="flex-row cookie_modal-row">
          <div class="col-3 cookie_modal-img">
            <img src="/images/icons/cookie.svg" alt="cookie img">
          </div>
          <div class="col-9 cookie_modal-content">
            <default-title
              :title="$t('text.cookie_title')"
              tiny
              title_tag="div"
            />
            <html-block
              :content="$t('text.cookie_text')"
            />
            <default-button
              class="mt-30"
              bordered
              is_light
              @click="submitCookie">
              Accept Cookies
            </default-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {ssr_window} from "../../helpers/ssr";
import DefaultTitle from "../small_parts/DefaultTitle.vue";
import DefaultButton from "../slots/DefaultButton.vue";
import HtmlBlock from "../small_parts/HtmlBlock.vue";

const STORAGE_NAME = 'shown_cookie_info'
const SHOWN_COOKIE = ssr_window.localStorage?.getItem(STORAGE_NAME) || ''
export default {
  name: 'CookieModal',
  components: {HtmlBlock, DefaultButton, DefaultTitle},
  mounted() {
    if (SHOWN_COOKIE) return
    setTimeout(() => {
      this.showModal(true)
    }, 1000)
  },
  data() {
    return {
      render: !SHOWN_COOKIE,
      show: false
    }
  },
  methods: {
    showModal(bool) {
      this.show = bool
    },
    submitCookie() {
      ssr_window.localStorage.setItem(STORAGE_NAME, '1')
      this.showModal(false)
    }
  },
}
</script>
